import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GoogleIcon from '@mui/icons-material/Google';
import {TikTokIcon} from "@/ui/tiktok-icon/tiktokIcon";
import {BUSINESS_NAME, googleDetails, socialMediaProfiles} from "@/content";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {useTheme} from "@mui/material/styles";

type SocialFooterBlockProps = {
    hideHandles: boolean;
}

const SocialFooterBlock = ({hideHandles} : SocialFooterBlockProps) => {
    const {
        facebookHandle,
        instaHandle,
        tikTokHandle,
        youTubeHandle,
        facebookLink,
        instaLink,
        tikTokLink,
        linkedInLink,
        youTubeLink,
        linkedInHandle,
    } = socialMediaProfiles;

    const {
        googleHandle,
        googleLink
    } = googleDetails;

    const theme = useTheme();

    const renderSocialListing = (
        IconComponent: React.ElementType,
        title: string,
        link: string,
        handle: string | undefined,
        businessName: string
    ) => {
        if (!handle?.length) return null;

        return (
            <Box
                sx={(theme: Theme) => ({
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'center',
                    backgroundColor: theme.custom.footer.socialFooterBackgroundColor,
                    mb: 1,
                    width: 'max-content',
                    py: 0.25,
                    px: 1
                })}
            >
                {!hideHandles && (
                    <Typography variant='body2' component='body2'
                                sx={(theme: Theme) => ({
                                    color: theme.custom.footer.titleColor,
                                })}
                    >
                        {title}
                    </Typography>
                )}
                <div className="social-listing">
                    <Box
                        sx={(theme: Theme) => ({
                            color: theme.custom.footer.titleColor,
                            display: 'flex',
                            gap: '10px',
                        })}
                    >
                        <IconComponent {...(title === 'TikTok' ? {color: theme.custom.footer.titleColor} : {})} />
                        <a
                            href={`${link}${handle}`}
                            target="_blank"
                            title={`${businessName} on ${title}`}
                            rel="nofollow"
                        >
                            {hideHandles ? title : title === 'Instagram' ? `@${handle}` : handle}
                        </a>
                    </Box>
                </div>
            </Box>
        );
    };

    return (
        <div className="social-footer-block">
            <Box className="footerTitle"
                 sx={(theme: Theme) => ({
                     color: theme.custom.footer.titleColor,
                 })}
            >
                Follow us
            </Box>
            {renderSocialListing(InstagramIcon, 'Instagram', instaLink, instaHandle, BUSINESS_NAME)}
            {renderSocialListing(YouTubeIcon, 'Youtube', youTubeLink, youTubeHandle, BUSINESS_NAME)}
            {renderSocialListing(TikTokIcon, 'TikTok', tikTokLink, tikTokHandle, BUSINESS_NAME)}
            {renderSocialListing(FacebookIcon, 'Facebook', facebookLink, facebookHandle, BUSINESS_NAME)}
            {renderSocialListing(LinkedInIcon, 'LinkedIn', linkedInLink, linkedInHandle, BUSINESS_NAME)}
            {renderSocialListing(GoogleIcon, 'Google', googleLink, googleHandle, BUSINESS_NAME)}
        </div>
    );
};

export default SocialFooterBlock;
